export default __webpack_public_path__ + "static/media/guide14.cf7f5811.png";